export const environment = {
  version: '1.36',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
